import { render, staticRenderFns } from "./PersonalizationMicrosoftModal.vue?vue&type=template&id=50ab3775&scoped=true"
import script from "./PersonalizationMicrosoftModal.vue?vue&type=script&lang=js"
export * from "./PersonalizationMicrosoftModal.vue?vue&type=script&lang=js"
import style0 from "./PersonalizationMicrosoftModal.vue?vue&type=style&index=0&id=50ab3775&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ab3775",
  null
  
)

export default component.exports